module.exports = __webpack_public_path__ + "img/xsgd.26882529.png";